function calculateMinutes(month, year) {
  return window.$http({
    url: `/api/v1/training/calculate-minutes/${month}/${year}`,
    method: 'get',
  });
}

export default calculateMinutes;
